module.exports = __webpack_public_path__ + "20db788959906061c12e40843fcf57e2.png";